// Libs
import React, { ReactElement } from 'react';
import { Skeleton, useMediaQuery, useTheme } from 'ui-components';
// App
import headerStyles from './content-card-header.module.scss';
import imageStyles from './content-card-main-image.module.scss';
import mainInformationStyles from './content-card-main-information.module.scss';

/**
 * Skeleton for content card header
 * @param props the props
 */
const ContentCardHeaderSkeleton = (props: { animation?: false | 'pulse' | 'wave' }): ReactElement => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { animation } = props;

  return (
    <div className={headerStyles.container}>
      <div className={imageStyles.container}>
        <Skeleton
          className={imageStyles.imageContainer}
          variant="rectangular"
          width={(isSmallScreen && '100%') || 600}
          height={(isSmallScreen && 232) || 400}
          animation={animation}
        />
      </div>
      <div className={mainInformationStyles.container}>
        <Skeleton variant="text" width="100%" animation={animation} />
        <Skeleton variant="text" width="50%" animation={animation} />
        <Skeleton variant="text" width="50%" animation={animation} />
        <Skeleton variant="text" width="50%" animation={animation} />
        <Skeleton variant="text" width="50%" animation={animation} />
      </div>
    </div>
  );
};

export default ContentCardHeaderSkeleton;
